import { Outlet, matchPath, useLocation } from 'react-router-dom';
import { IconNavArchiveBox, IconNavListBullet } from '../../components/icons';
import { AppShellGrid, type NavEntry } from '../../components/Sidebar';
import { useDict } from '../../i18n/dictionary';
import { useAppCrumb } from '../../layouts/AppLayout';
import { checklistsDict } from './i18n';

/**
 * The overview, lit on a list, its form and the new-list page too, which are
 * all reached from it; and the groups. A prefix match on `/checklists` would
 * light the overview on the Groups page as well, and so would the `:id`
 * pattern, so the overview matches exactly and drops its patterns there.
 */
export function ChecklistsLayout() {
  const t = useDict(checklistsDict);
  useAppCrumb('checklists', t.appName, '/checklists');
  const { pathname } = useLocation();
  const onGroups = matchPath('/checklists/groups', pathname) !== null;
  const nav: NavEntry[] = [
    {
      key: 'checklists',
      href: '/checklists',
      label: t.checklists,
      icon: IconNavListBullet,
      end: true,
      activeOn: onGroups
        ? []
        : ['/checklists/new', '/checklists/:id', '/checklists/:id/edit'],
    },
    {
      key: 'groups',
      href: '/checklists/groups',
      label: t.groups,
      icon: IconNavArchiveBox,
    },
  ];
  return (
    <AppShellGrid items={nav}>
      <Outlet />
    </AppShellGrid>
  );
}
